import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";

Vue.config.productionTip = false;

// define event bus and make it available everywhere
const eventBus = new Vue();
Object.defineProperties(Vue.prototype, {
  $eventBus: {
    get: function () {
      return eventBus
    }
  }
})

new Vue({
  render: h => h(App),
  router,
  store
}).$mount("#app");